
import { useToastContext } from "components/alert/ToastContext";
import BaseListagem from "components/BaseListagem";
import ReportEdit from "components/reports/ReportEdit";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterApplyTemplateOptions, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import ProdutoService from "service/administracao/cadastro/produto/ProdutoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { booleanFilterTemplate, IdMatchModeOptions, TextMatchModeOptions } from "utils/filterUtils";
import saveAs from 'file-saver';
import { Checkbox } from "primereact/checkbox";

const produtoService = new ProdutoService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function ProdutoListagem() {

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    const [familias, setFamilias] = useState<FamiliaProduto[]>([]);
    const [origens, setOrigens] = useState<OrigemProduto[]>([]);
    const [visibleDialogRelatorios, setVisibleDialogRelatorios] = useState(false);
    const [editaRelatorios, setEditaRelatorios] = useState(false);

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_PRODUTO_LISTAGEM_EDITAR"])) {
                setEditaRelatorios(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
        produtoService.familias().then(lista => {
            setFamilias(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoService.origens().then(lista => {
            setOrigens(lista);
        }).catch(err => {
            console.log(err);
        });

    }, []);

    function getButtonsExtra() {
        return [
            editaRelatorios ? <SplitButton
                icon="pi pi-file-pdf"
                style={{ marginRight: 8 }}
                onClick={() => gerarRelatorioListagem()}
                model={[{
                    label: "Alterar relatórios",
                    command: () => setVisibleDialogRelatorios(true)
                }]}
            /> : <Button
                type="button"
                icon="pi pi-file-pdf"
                style={{ marginRight: 8 }}
                onClick={() => gerarRelatorioListagem()}
            />
        ]
    }

    function gerarRelatorioListagem() {
        startLoading();
        produtoService.getRelatorioListagem(filters).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `Produtos.pdf`);
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err.message);
            console.log(err);
        });
    }

    const familiaFilterField = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={familias} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="codigo" placeholder="Qualquer" className="p-column-filter" />
    }


    const origemFilterField = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={origens} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="codigo" placeholder="Qualquer" className="p-column-filter" />
    }

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        codigo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        origemProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        familiaProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        ativo: {
            constraints: [
                {
                    value: true,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);


    const filterApplyTemplate = (options: ColumnFilterApplyTemplateOptions) => {
        return <Button type="button" label="Aplicar" onClick={options.filterApplyCallback} ></Button>;
    };

    return (
        <>
            <Dialog visible={visibleDialogRelatorios}
                onHide={() => setVisibleDialogRelatorios(false)}
                header="Relatórios"
                style={{ width: "50%" }}
            >
                <ReportEdit nomeAcao="RELATORIO_PRODUTO_LISTAGEM_EDITAR" titulo="Relatório de listagem" testarRelatorio={() => { }} style={{ marginBottom: 10 }} />
            </Dialog>
            <BaseListagem
                ordenacao="id.codigo,ASC" service={produtoService} urlService="/produto"
                onChangeFilters={(filters) => setFilters(filters)}
                buttonsExtra={getButtonsExtra()} tituloPagina={'Produtos'}
                defaultFilters={defaultFilters}
                showClearFilterButton nome="produto"
            >
                <Column field="codigo" header="Código" style={{ width: '10em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="familiaProduto.origemProduto.nome" header="Origem" style={{ width: '15em' }} filter filterField="origemProduto" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={origemFilterField} />
                <Column field="familiaProduto.nome" header="Família" style={{ width: '15em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="familiaProduto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={familiaFilterField} />
                <Column field="ativo" header="Ativo" body={(rowData) => <Checkbox checked={rowData.ativo} readOnly />} style={{ width: '5em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={booleanFilterTemplate} />
            </BaseListagem>
        </>

    )
}